export default __webpack_public_path__ + "static/media/youtube.75a3ba0d.png";